module.exports = __webpack_public_path__ + "static/media/payment.dd443086.jpeg";